import {LoginState, LoginStateStore, UserData} from '../Types/LoginState';

const loginStorageKey = 'loginStorageKey';

export async function initializeLoginState(): Promise<void> {
  const loginElement = <HTMLElement | null>document.querySelector('.js-login-box-header');
  const url = loginElement?.dataset?.loginStatusUrl;
  if (!url) {
    return;
  }
  const response = await fetch(url);
  const initialUserData = <UserData> await response.json();
  // TODO: store more User Data in sessionStorage
  setLoginStateGlobally(initialUserData.loggedIn ? 'loggedIn' : 'loggedOut', initialUserData.usergroup ?? '');
}

export const setLoginStateGlobally = (state: LoginState, usergroups: string): void => {
  sessionStorage.setItem(loginStorageKey, state);
  sessionStorage.setItem(loginStorageKey + 'UserGroups', usergroups);
};

export function getStoredLoginState(): LoginStateStore {
  const loginState: LoginState | null = <LoginState | null>sessionStorage.getItem(loginStorageKey);
  const userGroups: string = sessionStorage.getItem(loginStorageKey + 'UserGroups') || '';
  if (!loginState) {
    setLoginStateGlobally('loggedOut', '');
    return {
      loginState: 'loggedOut',
      userGroups,
    };
  }
  return {
    loginState,
    userGroups,
  };
}
